import { EmojiData } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { IMainLang } from '@interfaces/languages/main-lang';

export const tofu =
    // eslint-disable-next-line max-len
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTMsM0gyMVYyMUgzVjNNNSw1VjE5SDE5VjVINVoiIC8+PC9zdmc+';

export const defaultBaseUrl = 'assets/images/emoji';
export const defaultSize = 24;
export const defaultIconSet: IconSet = 'apple';
export const defaultSheetSize: SheetSize = 64;

export type IconSet = 'apple' | 'google' | 'twitter' | 'facebook';
export type SheetSize = 16 | 20 | 32 | 64 | 72;
export type EmojiUrlFn = (emoji: EmojiData | string | null) => string;

/**
 * Конфигурация для емотиконов.
 */
export interface IEmojiConfig {
    /**
     * URL к папке с картинками для эмотиконов. Например, "assets/images/emoji".
     */
    baseUrl: string;

    /**
     * Параметр "emojiSize" для внешнего компонента ngx-emoji-mart.
     */
    size: number;

    /**
     * Параметр "set" для внешнего компонента ngx-emoji-mart.
     */
    iconSet: IconSet;

    /**
     * Параметр "sheetSize" для внешнего компонента ngx-emoji-mart.
     */
    sheetSize: SheetSize;
}

/**
 * Тип данных локализации емозди пикера.
 */
export type TEmojiMartLocale = {
    search: string;
    emojilist: string;
    notfound: string;
    clear: string;
    categories: {
        search: string;
        recent: string;
        people: string;
        nature: string;
        foods: string;
        activity: string;
        places: string;
        objects: string;
        symbols: string;
        flags: string;
        custom: string;
    };
    skintones: {
        1: string;
        2: string;
        3: string;
        4: string;
        5: string;
        6: string;
    };
};

/**
 * Настройки по-умолчанию.
 */
export const defaultConfig: IEmojiConfig = {
    baseUrl: defaultBaseUrl,
    iconSet: defaultIconSet,
    sheetSize: defaultSheetSize,
    size: defaultSize
};

/**
 * Преобразование локализации.
 */
export const toEmojiMartLocale = (locale: IMainLang): TEmojiMartLocale => ({
    search: locale.fui_pages_emoji_search,
    emojilist: locale.fui_pages_emoji_emojilist,
    notfound: locale.fui_pages_emoji_notfound,
    clear: locale.fui_pages_emoji_clear,
    categories: {
        search: locale.fui_pages_emoji_search_results,
        recent: locale.fui_pages_emoji_recent,
        people: locale.fui_pages_emoji_people,
        nature: locale.fui_pages_emoji_nature,
        foods: locale.fui_pages_emoji_foods,
        activity: locale.fui_pages_emoji_activity,
        places: locale.fui_pages_emoji_places,
        objects: locale.fui_pages_emoji_objects,
        symbols: locale.fui_pages_emoji_symbols,
        flags: locale.fui_pages_emoji_flags,
        custom: locale.fui_pages_emoji_custom,
    },
    skintones: {
        1: locale.fui_pages_emoji_skintone_1,
        2: locale.fui_pages_emoji_skintone_2,
        3: locale.fui_pages_emoji_skintone_3,
        4: locale.fui_pages_emoji_skintone_4,
        5: locale.fui_pages_emoji_skintone_5,
        6: locale.fui_pages_emoji_skintone_6,
    },
});
